import styled, { css } from 'styled-components';
import { Button as CustomButton } from 'react-bootstrap';

const BaseButton = styled(CustomButton)`
  border: ${props => props.theme.borders.none};
  border-radius: ${props => props.theme.borderRadius.medium};
  outline-color: transparent;
  outline-style: none;
  outline: 0;
  user-select: none;
  cursor: pointer;
  font-size: ${props => (props.textSmall
    ? props.theme.typography.fontSizeSmall
    : props.theme.typography.fontSize)};
  text-decoration: none;
  // text-wrap: nowrap;
  // white-space: nowrap; // Add this line to prevent text wrapping
  vertical-align: middle;
  // padding: 8px 35px;
  font-weight: 500;
  text-transform: uppercase;
  font-family: ${props => props.theme.typography.fontFamily};
  background-position: center;
  transition: all 0.25s cubic-bezier(0.02, 0.01, 0.47, 1);
  box-shadow: ${props => props.theme.shadows.small};
  ${props => props.block
    && css`
      display: block;
      width: 100%;
    `}
  ${props => props.large
    && css`
      padding: 15px 40px;
    `}
`;

const Button = styled(BaseButton)`
  // default
  background-color: ${props => props.theme.colors.light};
  color: ${props => props.theme.colors.primary};

  &:hover {
    background: ${props => props.theme.colors.primary};
    color: ${props => props.theme.colors.light};
  }

&.btn.btn-primary:active {
  background: ${props => props.theme.colors.primaryDeep};
  color: ${props => props.theme.colors.light};
}

      // primary
      ${props => props.primary
        && css`
          background-color: ${props => props.theme.colors.primary};
          color: ${props => props.theme.colors.light};
          &:hover {
            background: ${props => props.theme.colors.primaryDeep};
            color: ${props => props.theme.colors.light};
          }
          &.btn.btn-primary:active {
            background-color: ${props => props.theme.colors.primaryAccent};
            color: ${props => props.theme.colors.light};
          }
          &:disabled {
            background: ${props => props.theme.colors.darkLight};
            color: ${props => props.theme.colors.light};
          }
        `}


      // secondary
      ${props => props.secondary
        && css`
          background-color: ${props => props.theme.colors.secondary};
          color: ${props => props.theme.colors.light};
          &:hover {
            background: ${props => props.theme.colors.secondaryDeep};
            color: ${props => props.theme.colors.light};
          }
          &.btn.btn-primary:active {
            background-color: ${props => props.theme.colors.secondary};
            color: ${props => props.theme.colors.light};
          }
          &:disabled {
            background: ${props => props.theme.colors.darkLight};
            color: ${props => props.theme.colors.light};
          }
        `}

    //Accent
    ${props => props.pAccent
      && css`
        background-color: ${props => props.theme.colors.primaryAccent};
        color: ${props => props.theme.colors.light};
        font-weight: 500;
        padding: 13px 20px;
        &:hover {
          background: ${props => props.theme.colors.primaryAccentO};
          color: ${props => props.theme.colors.light};
        }
        &.btn.btn-primary:active {
          background-color: ${props => props.theme.colors.primaryAccentO};
          color: ${props => props.theme.colors.light};
        }
        &:disabled {
          background: ${props => props.theme.colors.darkLight};
          color: ${props => props.theme.colors.light};
        }
      `}

    // info
    ${props => props.info
      && css`
        background-color: ${props => props.theme.colors.info};
        color: ${props => props.theme.colors.light};
        &:hover {
          background: ${props => props.theme.colors.infoDeep};
          color: ${props => props.theme.colors.light};
        }
        &:active {
          background-color: ${props => props.theme.colors.infoLight};
          color: ${props => props.theme.colors.info};
        }
      `}


  ${props => props.danger
    && css`
      background-color: ${props => props.theme.colors.lightLight};
      color: ${props => props.theme.colors.danger};
      &:hover {
        background: ${props => props.theme.colors.dangerDeep};
        color: ${props => props.theme.colors.light};
      }
      // &:active {
      //   background-color: ${props => props.theme.colors.dangerLight};
      //   color: ${props => props.theme.colors.danger};
      }
    `}

    //danger Light
    ${props => props.dangerLight
      && css`
        background-color: ${props => props.theme.colors.dangerLight};
        color: ${props => props.theme.colors.danger};
        &:hover {
          background: ${props => props.theme.colors.dangerDeep};
          color: ${props => props.theme.colors.light};
        }
        &:active {
          background-color: ${props => props.theme.colors.dangerLight};
          color: ${props => props.theme.colors.danger};
        }
      `}

    ${props => props.warning
      && css`
        background-color: ${props => props.theme.colors.warning};
        color: ${props => props.theme.colors.light};
        &:hover {
          background: ${props => props.theme.colors.warningDeep};
          color: ${props => props.theme.colors.light};
        }
        &:active {
          background-color: ${props => props.theme.colors.warningLight};
          color: ${props => props.theme.colors.warning};
        }
      `}

        // success


          ${props => props.success
            && css`
              background-color: ${props => props.theme.colors.successLight};
              color: ${props => props.theme.colors.success};
              &:hover {
                background: ${props => props.theme.colors.successDeep};
                color: ${props => props.theme.colors.light};
              }
              &:active {
                background-color: ${props => props.theme.colors.successLight};
                color: ${props => props.theme.colors.success};
              }
            `}

          // primarylight
          ${props => props.pLight
            && css`
              background-color: ${props => props.theme.colors.primaryComplementary1};
              color: ${props => props.theme.colors.primaryDeep};
              font-weight: 500;
              &:hover {
                background: ${props => props.theme.colors.info};
                color: ${props => props.theme.colors.light};
              }
              &:active {
                background-color: ${props => props.theme.colors.primaryLight};
                color: ${props => props.theme.colors.primary};
              }
            `}

            // White&Gray
          ${props => props.white
            && css`
              background-color: ${props => props.theme.colors.light};
              color: ${props => props.theme.colors.darkLight};
              font-weight: 600;
              &:hover {
                background: ${props => props.theme.colors.darkLight};
                color: ${props => props.theme.colors.light};
              }
              &:active {
                background-color: ${props => props.theme.colors.light};
                color: ${props => props.theme.colors.primary};
              }
            `}

          // Light
          ${props => props.light
            && css`
              display: flex;
              align-items: center;
              justify-content: space-around;
              min-width: 114px;
              background-color: ${props => props.theme.colors.lightLight};
              color: ${props => props.theme.colors.dark};
              border: 1px solid ${props => props.theme.colors.primaryComplementary1};
              &:hover {
                background: ${props => props.theme.colors.primaryLight};
                color: ${props => props.theme.colors.primary};
                border: 1px solid ${props => props.theme.colors.primaryComplementary1};
              }
              &:active {
                background-color: ${props => props.theme.colors.primaryLight};
                color: ${props => props.theme.colors.primary};
              }
            `}

            // Black
            ${props => props.dark
              && css`
                background-color: ${props => props.theme.colors.dark};
                color: ${props => props.theme.colors.brand};
                &:hover {
                  background: ${props => props.theme.colors.darkDeep};
                  color: ${props => props.theme.colors.light};
                }
                &:active {
                  background-color: ${props => props.theme.colors.darkLight};
                  color: ${props => props.theme.colors.dark};
                }
              `}

`;

const IconButton = styled.button`
  display: inline;
  align-content: center;
  text-align: center;
  justify-items: center;
  justify-content: center;
  border-radius: 8px;
  width: 30px;
  height: 30px;
  cursor: pointer;
  text-decoration: none;
  border: 0;
  vertical-align: middle;
  color: ${props => props.theme.colors.primary};
  background-color: ${props => props.theme.colors.light};
  background-position: center;
  font-size: ${props => props.theme.typography.fontSizeSmall};
  font-weight: 600;
  font-family: ${props => props.theme.typography.fontFamily};

  &:hover {
    background: ${props => props.theme.colors.primary};
    color: white;
  }
  &:active {
    background-color: ${props => props.theme.colors.primaryDeep};
  }
  ${props => props.primary
    && css`
      background: ${props => props.theme.colors.default};
      color: ${props => props.theme.colors.default};
      &:hover {
        background: ${props => props.theme.colors.default};
        box-shadow: ${props => props.theme.shadows.small};
        color: ${props => props.theme.colors.light};
      }
      &:active {
        background-color: ${props => props.theme.colors.default};
      }
    `}
  ${props => props.danger
    && css`
      background: ${props => props.theme.colors.danger};
      color: ${props => props.theme.colors.light};
      &:hover {
        background: ${props => props.theme.colors.dangerDeep};
        box-shadow: ${props => props.theme.shadows.small};
        color: ${props => props.theme.colors.light};
      }
      &:active {
        background: ${props => props.theme.colors.dangerLight};
        color: ${props => props.theme.colors.dangerDeep};
      }
    `}
	${props => props.success
    && css`
      background: ${props => props.theme.colors.success};
      color: ${props => props.theme.colors.light};
      &:hover {
        background: ${props => props.theme.colors.successDeep};
        box-shadow: ${props => props.theme.shadows.small};
        color: ${props => props.theme.colors.light};
      }
      &:active {
        background: ${props => props.theme.colors.successLight};
        color: ${props => props.theme.colors.successDeep};
      }
    `}
    ${props => props.info
      && css`
        background: ${props => props.theme.colors.primaryLight};
        color: ${props => props.theme.colors.info};
        &:hover {
          background: ${props => props.theme.colors.default};
          box-shadow: ${props => props.theme.shadows.small};
          color: ${props => props.theme.colors.default};
        }
        &:active {
          background-color: ${props => props.theme.colors.default};
        }
      `}
  ${props => props.warning
    && css`
      background: ${props => props.theme.colors.default};
      color: ${props => props.theme.colors.default};
      &:hover {
        background: ${props => props.theme.colors.default};
        box-shadow: ${props => props.theme.shadows.small};
        color: ${props => props.theme.colors.light};
      }
      &:active {
        background-color: ${props => props.theme.colors.default};
      }
    `}

    ${props => props.fill
      && css`
        background: ${props => props.theme.colors.default};
        color: ${props => props.theme.colors.default};
        &:hover {
          background: ${props => props.theme.colors.default};
          box-shadow: ${props => props.theme.shadows.small};
          color: white;
        }
        &:active {
          background-color: ${props => props.theme.colors.default};
        }
      `}
  `;

const TextButton = styled.button`
display: inline-block;
user-select: none;
cursor: pointer;
text-decoration: none;
vertical-align: middle;
padding: 7.5px 12px;
background-color: ${props => props.theme.colors.default};
border: 0;
border-radius: 5px;
background-position: center;
transition: all 0.25s cubic-bezier(0.02, 0.01, 0.47, 1);
font-size: ${props => props.theme.typography.fontSize};
font-weight: 500;
font-family: ${props => props.theme.typography.fontFamily};
color: ${props => props.theme.colors.primary};
&:hover {
  color: ${props => props.theme.colors.default};
  background: ${props => props.theme.colors.secondaryLight};
}
&:active {
  background-color: ${props => props.theme.colors.default};
  color: ${props => props.theme.colors.default};
}

  //Link
  ${props => props.link
    && css`
      color: ${props => props.theme.colors.default};
      border: 0;
      padding: 0px;
      background-color: transparent;
      text-decoration: underline;
      &:hover {
        border: 0;
        color: ${props => props.theme.colors.default};
        background-color: transparent;
        border-radius: none;
        transition: none;
      }
      &:active {
        color: ${props => props.theme.colors.default};
      }
    `}

    //Text
    ${props => props.text
      && css`
        color: ${props => props.theme.colors.default};
        border: 0;
        background-color: transparent;
        &:hover {
          border: 0;
          color: ${props => props.theme.colors.default};
          background-color: ${props => props.theme.colors.default};
        }
        &:active {
          color: ${props => props.theme.colors.default};
        }
      `}
`;
const ButtonSearchIcon = styled.button`
  border-top: 1px solid ${props => props.theme.colors.primary};
  border-right: 1px solid ${props => props.theme.colors.primary};
  border-bottom: 1px solid ${props => props.theme.colors.primary};
  border-left: 0px;
  padding-left: 15px;
  padding-right: 15px;
  border-radius: 0;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 500;
  font-family: inherit;
  color: ${props => props.theme.colors.light};
  background-color: transparent;
  &:hover {
    background: ${props => props.theme.colors.primary}};
    color: white;
  }
  ${({ globalSearchButton }) => globalSearchButton
    && css`
    border-top: 0px;
    border-right: 0px;
    border-bottom: 1px solid white;
    border-left: 0px;
    color: white;
    background-color: inherit;
}
`}
`;

export {
  TextButton, IconButton, Button, ButtonSearchIcon,
};
